import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { forwardRef } from "react";

import styled from "styled-components/macro";

import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { faSearch } from "@fortawesome/pro-solid-svg-icons";

import FnrInput3 from "UI/FnrInput3";
import { colors } from "UI/colors";

const SearchBar = ({ searchTerm, setSearchTerm, isMobile }) => {
  const SearchInputPrefixComponent = forwardRef((props, ref) => {
    return (
      <SearchInputPrefix ref={ref}>
        <FontAwesomeIcon icon={faSearch} size="sm" color={colors.fnLtGray} />
      </SearchInputPrefix>
    );
  });

  const SearchInputSuffixComponent = forwardRef((props, ref) => {
    if (!searchTerm) return null;

    return (
      <SearchInputSuffix ref={ref} onClick={() => setSearchTerm("")}>
        <FontAwesomeIcon icon={faTimes} size="sm" color={colors.fnLtGray} />
      </SearchInputSuffix>
    );
  });

  return (
    <SearchContainer $isMobile={isMobile}>
      <SearchInput
        PrefixComponent={SearchInputPrefixComponent}
        SuffixComponent={SearchInputSuffixComponent}
        placeholder="Search notes..."
        value={searchTerm}
        setValue={setSearchTerm}
      />
    </SearchContainer>
  );
};

const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const SearchInput = styled(FnrInput3)`
  margin-right: 20px;
  & input {
    border: none;
    color: #ffffff;
    font-size: 14px;
    border-radius: 30px;
    padding: 8px 12px 8px 40px;
    background: linear-gradient(
      140deg,
      rgba(0, 0, 0, 0.35) 0%,
      rgba(0, 0, 0, 0.55) 100%
    );
    transition: scale 0.3s;
    &:focus {
      scale: 1.02;
      transition: scale 0.3s;
    }
    &::placeholder {
      color: #ffffffaa;
    }
  }
`;

const SearchInputPrefix = styled.div`
  position: absolute;
  transform: translateY(-50%);
  top: 19px;
  left: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`;

const SearchInputSuffix = styled.div`
  position: absolute;
  transform: translateY(-50%);
  top: 18px;
  right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #ffffff !important;
  }
`;

export default SearchBar;
